import { __assign, __generator } from "tslib";
import axios from 'axios';
import { call, select } from 'redux-saga/effects';
import { ConfigSelectors } from '../config';
import ddt from '@wix/da-ddt';
import { CANCEL } from 'redux-saga';
import { getPublicSession } from '../publicSession/selectors';
var CANONICAL_XHR_ENDPOINT = 'https://www.deviantart.com/_napi/shared_api/';
var LOCAL_XHR_ENDPOINT = 'https://www.deviantart.lan/_napi/shared_api/';
function getFakeResponse(response) {
    if (process.env.NODE_ENV === 'test') {
        return response;
    }
    return new Promise(function (resolve) {
        setTimeout(function () { return resolve(response); }, 1000);
    });
}
function getApiResponse(options) {
    var cancelTokenSource = axios.CancelToken.source();
    var promise = axios
        .request(options.enableCancellation
        ? __assign(__assign({}, options), { cancelToken: cancelTokenSource.token }) : options)
        .then(function (response) {
        return response.data;
    })
        .catch(function () {
        return false;
    });
    // redux saga calls this special prop when it cancel the outer saga E.g. takeLatest
    if (options.enableCancellation) {
        promise[CANCEL] = function () { return cancelTokenSource.cancel(); };
    }
    return promise;
}
export function isApiError(response) {
    return response.error;
}
export function request(options, fakeResponse) {
    var _a, csrf, withCreds, session, result, doFake;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!(options.baseURL === undefined)) return [3 /*break*/, 3];
                if (!(process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm')) return [3 /*break*/, 2];
                _a = options;
                return [4 /*yield*/, select(ConfigSelectors.key('sharedApiBasePath'))];
            case 1:
                _a.baseURL = _c.sent();
                return [3 /*break*/, 3];
            case 2:
                if (window['__XHR_LOCAL__']) {
                    options.baseURL = LOCAL_XHR_ENDPOINT;
                    // Production goes to the xhr server
                }
                else {
                    options.baseURL = CANONICAL_XHR_ENDPOINT;
                }
                _c.label = 3;
            case 3: return [4 /*yield*/, select(ConfigSelectors.key('csrfToken'))];
            case 4:
                csrf = _c.sent();
                if (options.method && options.method.toLowerCase() === 'post') {
                    if (options.data === undefined) {
                        options.data = {};
                    }
                    options.data['csrf_token'] = csrf;
                }
                else {
                    if (options.params === undefined) {
                        options.params = {};
                    }
                    options.params['csrf_token'] = csrf;
                }
                return [4 /*yield*/, select(ConfigSelectors.key('withCredentials'))];
            case 5:
                withCreds = _c.sent();
                if (withCreds) {
                    options.withCredentials = true;
                }
                return [4 /*yield*/, select(getPublicSession)];
            case 6:
                session = _c.sent();
                if ((_b = session === null || session === void 0 ? void 0 : session.device) === null || _b === void 0 ? void 0 : _b.supportsWebp) {
                    options.headers = __assign(__assign({}, options.headers), { Accept: 'application/json, text/plain, image/webp, */*' });
                }
                if (!(process.env.NODE_ENV !== 'production')) return [3 /*break*/, 9];
                if (!(fakeResponse !== undefined)) return [3 /*break*/, 9];
                return [4 /*yield*/, select(ConfigSelectors.key('fakeApiRequests'))];
            case 7:
                doFake = _c.sent();
                if (!doFake) return [3 /*break*/, 9];
                ddt.log('saga', "Faked XHR for: ".concat(options.url), options, fakeResponse(options));
                return [4 /*yield*/, call(getFakeResponse, fakeResponse(options))];
            case 8:
                result = _c.sent();
                return [2 /*return*/, result];
            case 9: return [4 /*yield*/, call(getApiResponse, options)];
            case 10:
                result = _c.sent();
                return [2 /*return*/, result];
        }
    });
}
//# sourceMappingURL=request.js.map